import Axios from 'axios';

const token = localStorage.getItem('token');
// console.log({token});
let headers = {};
if(token!==undefined && token!== null){
    headers={
        Authorization: 'Bearer '+ token,
        // Content-Type: "application/json"
    } 
}
// axios instance create
export const axios = Axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  // baseURL: "http://localhost:8000/api/v1/",
  headers: headers
});

/**
 * The backend sends `statusCode: "401"` when the session is no longer usable —
 * the account was switched off in Users, or the token was blacklisted by a login
 * from another device. That has to end the session wherever the call was made
 * from: `customApiHandler` already handled it, but ~30 screens call this instance
 * directly and used to just show an error and leave the user sitting on the page.
 *
 * Redirect only (no toast) — the caller's own catch block reports the message —
 * and only once, so a screen firing several requests in parallel does not queue
 * up a stack of redirects.
 */
let sessionEndedHandled = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.data?.statusCode === '401' &&
      !sessionEndedHandled &&
      window.location.pathname !== '/login'
    ) {
      sessionEndedHandled = true;
      // Delay so the caller's error toast is readable before the page changes.
      setTimeout(() => {
        localStorage.clear();
        window.location.href = '/login';
      }, 1500);
    }
    return Promise.reject(error);
  }
);

export default axios;
